import { IAIState } from './ai.props';

const initialState: IAIState = {
  suggestionsById: {},
  suggestionsOrder: [],
};

export { initialState };
